import assetPath from '/opt/actions-runner/_work/crate/crate/xinglets/lebenslauf/components/frame/src/assets/favicon.ico';
export default [globalThis.crate.assetsBaseUrl, assetPath].join('/')